import { render, staticRenderFns } from "./OfficeDetails.vue?vue&type=template&id=8491e666&"
import script from "./OfficeDetails.vue?vue&type=script&lang=js&"
export * from "./OfficeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports